export default {"src":"/_next/static/media/arrow-up.f1d1d9a0.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};